<template>
  <div v-if="show">
    <div class="background-color-whitesmoke margin-10 padding-10">
      <weex-text class="item-sm-bold-heading">INSTRUCTIONS</weex-text>
      <weex-text class="margin-top-10 font-size-sm-base">{{ instructionHeader }}</weex-text>
      <div
        class="background-color-white margin-top-10 margin-bottom-10 margin-left-5 margin-right-5"
        v-for="instruction in instructions"
        :key="instruction">
        <weex-text
          class="padding-10"
          v-html="instruction"
          ></weex-text>
      </div>
    </div>

    <div class="background-color-whitesmoke margin-10 padding-10">
      <weex-text class="item-sm-bold-heading">CHOOSE OPTION</weex-text>

      <wxc-radio
        :list="options"
        :config="radioButtonConfig"
        :radio-button-on-right="false"
        @wxcRadioListChecked="onOptionSelected"
        ></wxc-radio>

      <wxc-button
        text="Continue"
        size="full"
        class="horizontal_center margin_top_20"
        type="blue"
        @wxcButtonClicked="onSubmit"
        ></wxc-button>
    </div>

  </div>
</template>
<script>
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import WxcRadio from "../../../weex-ui/packages/wxc-radio/index";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
  import AlertService from "../core/alert/AlertService";

  export default {
    name: 'BankStatementOptionsItem',
    components: { WxcRadio, WxcButton },
    data: () => ({
      title: "Bank Statement Options",
      selectedOption: ""
    }),

    props: {
      show: {
        type: Boolean,
        default: true
      },

      instructions: {
        type: Array,
        default: () => (["Please take the photo which customer name on it"])
      },

      options: {
        type: Array,
        default: () => ([])
      }
    },

    computed: {
      instructionHeader() {
        return "Bank Statements are required for further processing. Please ensure the following checklist is complete, else loan will not be approved.";
      },

      radioButtonConfig() {
        return DefaultResourceConfig.RADIO_BUTTON
      },
    },

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      onOptionSelected(e) {
        this.selectedOption = e.value;
      },

      onSubmit() {
        if (this.selectedOption) {
          this.$emit("onBankStatementOptionSelected", this.selectedOption);
        } else {
          this.showToast(MessageConstants.DOCUMENT_OPTIONS_NOT_SELECTED);
        }
      }
    }
  }

</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
